import { Injectable } from '@angular/core';
import { CanActivate, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, withLatestFrom, take } from 'rxjs/operators';
import { DriverStatus } from '@cordic/driver-management';
import { AppRoutes } from 'src/app/app-routes';
import { DeviceStoreService } from 'src/app/services/device-store/device-store.service';

@Injectable({
  providedIn: 'root'
})
export class VerificationRequiredGuard implements CanActivate
{
  constructor(
    private router: Router,
    private deviceStore: DeviceStoreService
  )
  { }

  canActivate(): Observable<boolean | UrlTree>
  {
    return this.deviceStore.getSession().pipe(
      take(1),
      withLatestFrom(this.deviceStore.getIsSignedOn()),
      map(([session, isSignedOn]) =>
      {
        if (session && session.driverStatus === DriverStatus.REGISTERED)
        {
          if (isSignedOn)
          {
            return true;
          }
          return this.router.createUrlTree([AppRoutes.PhoneConfirm]);
        }
        return true;
      })
    );
  }

}
